import styled from 'styled-components';

export const Container = styled.div`
  min-width: 240px;
  min-height: 64px;

  padding: 16px 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 24px;

  background-color: ${({ theme }) => theme.colors.greys.lightMedium};
  border-radius: 8px;
`;

export const ValueColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const LoadingContainer = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
`;
